import React, { useEffect, useState } from 'react';
import Map, { Marker } from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';

interface MapWrapperProps {
  geoImg?: string;
  latLong: number[]; // [latitude, longitude]
}

function MapWrapper({ geoImg, latLong }: MapWrapperProps) {
  const [viewState, setViewState] = useState({
    latitude: latLong[0],
    longitude: latLong[1],
    zoom: 15,
  });

  useEffect(() => {
    if (latLong && latLong.length >= 2) {
      setViewState({
        latitude: latLong[0],
        longitude: latLong[1],
        zoom: 15,
      });
    }
  }, [latLong]);

  if (!latLong || latLong.length < 2 || !latLong[0] || !latLong[1]) {
    return (
      <span
        style={{
          background: '#eee',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        Location info not available
      </span>
    );
  }

  return (
    <Map
      {...viewState}
      onMove={(evt) => setViewState(evt.viewState)}
      style={{ width: '100%', height: '100%' }}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || ''}
      mapStyle="mapbox://styles/mapbox/streets-v11"
      data-test={'mapInfo'}
    >
      {geoImg && (
        <Marker latitude={latLong[0]} longitude={latLong[1]}>
          <img
            src={geoImg}
            alt="Icon"
            style={{ width: 30, height: 30, objectFit: 'contain' }}
          />
        </Marker>
      )}
    </Map>
  );
}

export default MapWrapper;
